import { useState, type FC, useEffect, useRef } from "react";
import { cx } from "../../../utils";

interface RadioProps {
  className?: string;
  labelClassName?: string;
  label?: string | JSX.Element;
  disabled?: boolean;

  // Standard HTML input props
  id: string;
  name: string;
  checked?: boolean;
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: (event: React.MouseEvent<HTMLInputElement>) => void;
}

export const Radio: FC<RadioProps> = ({
  label,
  className,
  onChange,
  ...props
}) => {
  const [value, setValue] = useState(false);

  const redioRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    setValue(Boolean(props.checked) || Boolean(props.value));
  }, [props.checked, props.value]);

  const isActive =
    Boolean(props.checked) || Boolean(props.value) || Boolean(value);
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions -- let it be
    <div
      className={cx("flex items-center gap-[6px]", className)}
      onClick={() => {
        if (redioRef.current) {
          redioRef.current.click();
        }
      }}
    >
      <input
        checked={isActive}
        className={cx(
          "transition:all box-border h-5 w-5 sr-only",
          isActive
            ? " text-primary-50 outline-2 outline-primary-500"
            : "border bg-white",
          className
        )}
        onChange={onChange}
        ref={redioRef}
        type="radio"
        {...props}
      />

      <div
        className={cx(
          isActive
            ? "bg-primary-50 border-primary-500 disabled:hover:border-primary-500"
            : "bg-white",
          "flex items-center justify-center shrink-0 w-5 h-5 border border-content-100 rounded-full cursor-pointer transition-colors duration-200 ease-in-out hover:border-content-100"
        )}
      >
        {isActive ? (
          <svg
            className="w-2.5 h-2.5 text-primary-500"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <circle cx="12" cy="12" r="10" />
          </svg>
        ) : null}
      </div>

      {label ? (
        <label
          className={cx(
            "ms-2 text-sm font-medium text-content-700",
            props.labelClassName
          )}
          htmlFor={props.name}
        >
          {label}
        </label>
      ) : (
        label
      )}
    </div>
  );
};
